import { Box } from "@mui/material";

const FlexBetween = ({ children, gap = 2, fullWidth = false, ...props }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap={gap}
      width={fullWidth ? "100%" : "auto"} // Ajout d'un mode pleine largeur optionnel
      {...props}
    >
      {children}
    </Box>
  );
};

export default FlexBetween;
